import React from "react";
import { Grid, Paper, Typography } from "@material-ui/core";

import { getFullName } from "../../utils";
import UpsertForm from "./UpsertForm";

const HouseholdSummary = ({ title, household }) => (
  <Paper style={{ padding: 16, height: "100%" }}>
    <Typography variant="subtitle1"><strong>{title}</strong></Typography>
    <Typography variant="body2">{getFullName(household)}</Typography>
    <Typography variant="body2">{household.address || "No street address"}</Typography>
    <Typography variant="body2">
      {[household.city, household.state, household.postalCode].filter(Boolean).join(", ") || "No city, state, or ZIP"}
    </Typography>
    <Typography variant="body2">
      Phones: {(household.phoneNumbers || []).map(phone => phone.phoneNumber).filter(Boolean).join(", ") || "None"}
    </Typography>
    <Typography variant="body2">
      Emails: {(household.emails || []).map(email => email.email).filter(Boolean).join(", ") || "None"}
    </Typography>
  </Paper>
);

const MergeHouseholdsForm = ({ mainHousehold, mergeHousehold, history }) => (
  <>
    <Grid container spacing={2} style={{ marginBottom: 16 }}>
      <Grid item xs={12} md={6}>
        <HouseholdSummary title="Household to keep and edit" household={mainHousehold} />
      </Grid>
      <Grid item xs={12} md={6}>
        <HouseholdSummary title="Household to merge" household={mergeHousehold} />
      </Grid>
    </Grid>
    <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
      Phone numbers and email addresses are shown above and will be preserved by the merge procedure. Edit only the retained household information below.
    </Typography>
    <UpsertForm
      household={mainHousehold}
      mergeHousehold={mergeHousehold}
      mode="merge"
      history={history}
    />
  </>
);

export default MergeHouseholdsForm;